import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "w-full text-center" }, /*#__PURE__*/_toDisplayString(`QANDAへの登録が完了しました。`), -1)
const _hoisted_3 = { class: "w-full text-center text-2xl mt-4 md:mt-6" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-sm" }, " ※ QANDA IDはアプリの「メニュー」→「マイページ」→「プロフィールを修正する」に移動後、一番下にスクールし、「QANDA unique ID」というところから確認できます。 ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 連携する ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: _ctx.modalSize,
    "is-overlay": "true",
    "hide-footer": _ctx.isRegistrationDone,
    onClose: _ctx.close
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isRegistrationDone ? "QANDAの登録ができました" : "QANDA連携"), 1)
    ]),
    body: _withCtx(() => [
      (_ctx.isRegistrationDone)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", null, [
              _createVNode("div", _hoisted_3, _toDisplayString(`QANDA ID：${_ctx.qandaId}`), 1)
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_m_text_field, {
                label: "QANDA ID",
                name: "name",
                type: "text",
                placeholder: "ここに「#を取って」QANDA IDを入力",
                value: "",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.qandaId = $event))
              })
            ]),
            _hoisted_6
          ]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.registerStudentForQanda
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["size", "hide-footer", "onClose"]))
}